import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeSpinner = function SvgLargeSpinner(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 68 68",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.818 34.015c0-10.602 8.595-19.197 19.197-19.197 10.602 0 19.197 8.595 19.197 19.197 0 10.602-8.595 19.197-19.197 19.197-2.807 0-5.518-.6-8.005-1.743a5.41 5.41 0 00-4.518 9.83 29.923 29.923 0 0012.523 2.731c16.577 0 30.015-13.438 30.015-30.015C64.03 17.438 50.592 4 34.015 4 17.438 4 4 17.438 4 34.015a5.41 5.41 0 1010.818 0z",
    clipRule: "evenodd"
  }));
};

export default SvgLargeSpinner;